import React, { Component } from 'react'
import { MuiGrid, MuiTypography, MuiInputBase, MuiFab, MuiAddCircle, MuiButton, MuiToolTip, MuiIconButton, MuiClear } from '../../../../../ui/MaterialUIComponents'

import theme from '../../../../../../assests/theme'
import * as StringReplacer from '../../../../../../i18n/StringReplacer'
import { DialogComponentUtil } from '..';
import spinner from "../../../../../ui/icons/spinner.gif";

class MultiPeriodRulesComponent extends Component {
	constructor(props) {
		super(props)
	}

	render() {
		const { i18n } = this.props
		return (
			<React.Fragment>
				<MuiGrid container>
					<MuiToolTip
						placement="top-start"
						title={StringReplacer.getFormatedMessage(i18n.multiPeriodRules.heading,
							{
								Subject: DialogComponentUtil.getSubjectsForTemplate(this.props),
								Grades: DialogComponentUtil.getToolTipString(this.props),
							})
						} >
						<MuiTypography style={theme.typography.h6} gutterBottom>
							{StringReplacer.getFormatedMessage(i18n.multiPeriodRules.heading,
								{
									Subject: DialogComponentUtil.getSubjectsForTemplate(this.props),
									Grades: DialogComponentUtil.getGradeForTemplate(this.props),
								})
							}
						</MuiTypography>
					</MuiToolTip>
				</MuiGrid>
				{/* MAin container */}
				<MuiGrid container >

					{/* label name */}
					<MuiGrid container xs={12} justify="center">
						<MuiGrid item xs={6} align="center" style={theme.tableHeaderStyle}>
							<MuiTypography style={theme.tableHeaderTextStyle}>{i18n.multiPeriodRules.periodLength}</MuiTypography>
						</MuiGrid>
						<MuiGrid item xs={6} align="center" style={theme.tableHeaderStyle}>
							<MuiTypography style={theme.tableHeaderTextStyle}>{i18n.multiPeriodRules.weeklyFrequency}</MuiTypography>
						</MuiGrid>
					</MuiGrid>
					<MuiGrid container xs={12} justify="center">

						{this.props.multiPeriod.preferences.map((preference, index) =>

							<MuiGrid container xs={12}>
								{/* lower box to enter the value */}
								<MuiGrid item xs={6} align="center" style={theme.gridTableSelectStyle} >
									<MuiInputBase
										style={{ width: "80%" }}
										type="number"
										value={preference.noOfStandardPeriods}
										onChange={(event) => { this.props.handleChange(event.target.value, "noOfStandardPeriods", index) }}
									/>
								</MuiGrid>

								<MuiGrid item xs={5} align="center" style={theme.gridTableSelectStyle} >
									<MuiInputBase
										style={{ width: "80%" }}
										type="number"
										value={preference.numberOfInstances}
										onChange={(event) => { this.props.handleChange(event.target.value, "numberOfInstances", index) }}
									/>
								</MuiGrid>

								< MuiGrid item xs={1} style={theme.gridTableClearButtonStyle} justify="center " alignContent="center">
									<MuiIconButton onClick={() => this.props.removeMultiPeriod(index)} id="delete">
										<MuiClear style={{ color: theme.palette.grey.dark }} />
									</MuiIconButton>
								</ MuiGrid>
							</MuiGrid>

						)}

					</MuiGrid>
					{/* add more */}
					<MuiGrid container onClick={() => { this.props.addMore() }} justify="center" alignItems="center" xs={12} style={theme.gridActionContainerStyle}>

						<MuiGrid item >
							<MuiAddCircle style={{ color: theme.palette.orange }} fontSize='large' />
						</MuiGrid>

						<MuiGrid item >
							<MuiTypography style={theme.addMoreStyle}>
								Add more
          </MuiTypography>
						</MuiGrid>
					</MuiGrid>
				</MuiGrid>

				{/* buttons  */}
				<MuiGrid container justify="flex-end" style={{ marginTop: "10px", paddingTop: "10px", borderTop: "1px solid " + theme.palette.grey.main }}>

					<MuiGrid item style={{ marginRight: "10px" }}>
						<MuiButton style={theme.secondaryButtonStyle} onClick={this.props.handleCloseForDialog}>
							Cancel
            </MuiButton>
					</MuiGrid>

					<MuiGrid item>
						{this.props.updateSchoolinformationInProgress ? <img src={spinner} alt="none" style={theme.spinnerImgStyleForButton} /> :
							<MuiButton disabled={this.props.disableEdit} style={this.props.disableEdit ? theme.primaryButtonDisabledStyle : theme.primaryButtonStyle} onClick={this.props.onClickOfSave}>
								{i18n.commonTexts.apply}
							</MuiButton>}
					</MuiGrid>
				</MuiGrid>
			</React.Fragment>
		)
	}
}
export default MultiPeriodRulesComponent